
export const currentBalanceConfig: StatCardConfig = {
  id: "balance",
  title: "Current Balance",
  value: "$2,529",
  change: "+42% last month",
  changeColor: "text-teal",
  bg: "bg-teal-soft",
  iconColor: "text-teal",
  iconBg: "bg-teal-icon",
  chartColor: "#13c2c2",
  chartType: "donut",
  chartData: [{ v: 72 }, { v: 28 }],
};

export const donutSegments = [
  { value: 72, color: "#13c2c2" },
  { value: 28, color: "#e8edf3" },
];
